// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__n1wF3","label":"SetPasswdForm_label__3uZVO"};